import termsData from "./termsData.json";

export { termsData };

export const defaultTerm = termsData[0];

export const getTermById = (id) => {
  if (!id) return defaultTerm;
  const normalizedId = String(id).toLowerCase().replace(/^#/, "");
  return (
    termsData.find(
      (term) =>
        term.id.toLowerCase() === normalizedId ||
        term.slug?.toLowerCase() === normalizedId
    ) || defaultTerm
  );
};

export const searchTerms = (query = "") => {
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) return termsData;
  return termsData.filter(
    (term) =>
      term.tabTitle.toLowerCase().includes(trimmed) ||
      term.shortTitle?.toLowerCase().includes(trimmed) ||
      term.summary?.toLowerCase().includes(trimmed)
  );
};

